module.exports = __webpack_public_path__ + "img/erp-feature4.edc0d8a4.png";